import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const SOCIALLINKSBLOCK_LEGACY_FIELD_ORDER = [
  "facebook_url",
  "twitter_url",
  "instagram_url",
  "linkedin_url",
  "tiktok_url",
  "google_url",
  "text_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  socialLinksBlockDescriptor: _generatedSocialLinksBlockDescriptor,
  socialLinksBlockBlocDefinition,
  socialLinksBlockDashboardLayout,
  socialLinksBlockConfig,
  socialLinksBlockResolveConfig,
  socialLinksBlockProperties,
} = doodBlockConfig(
  {
    name: "Social links",
    componentType: 'SocialLinksBlockComponent',
    category: 'content',
    description: "Social links.",
    keywords: [],
    allowedIn: [
      { bloc: '*Page', slot: '*' },
    ],
    sharedFields: {}
  },

  () => ({
    facebook_url: propertyValue({
      type: 'link',
      value: '',
      options: {
        label: "pages.blocks.social-links.facebook-url.label",
      }
    }),
    twitter_url: propertyValue({
      type: 'link',
      value: '',
      options: {
        label: "pages.blocks.social-links.twitter-url.label",
      }
    }),
    instagram_url: propertyValue({
      type: 'link',
      value: '',
      options: {
        label: "pages.blocks.social-links.instagram-url.label",
      }
    }),
    linkedin_url: propertyValue({
      type: 'link',
      value: '',
      options: {
        label: "pages.blocks.social-links.linkedin-url.label",
      }
    }),
    tiktok_url: propertyValue({
      type: 'link',
      value: '',
      options: {
        label: "pages.blocks.social-links.tiktok-url.label",
      }
    }),
    google_url: propertyValue({
      type: 'link',
      value: '',
      options: {
        label: "pages.blocks.social-links.google-url.label",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: { type: 'default', value: '' },
      options: {
        label: "pages.blocks.social-links.text-color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.social-links.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.social-links.fieldset.networks.label",
            fields: [
              "facebook_url",
              "twitter_url",
              "instagram_url",
              "linkedin_url",
              "tiktok_url",
              "google_url",
              "text_color",
            ],
          },
        ],
      },
    ],
  })
);

export function socialLinksBlockDescriptor(): IBlockDescriptor;
export function socialLinksBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function socialLinksBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedSocialLinksBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedSocialLinksBlockDescriptor, socialLinksBlockProperties, fieldOrder);
}

export {
  socialLinksBlockBlocDefinition,
  socialLinksBlockDashboardLayout,
  socialLinksBlockProperties,
  socialLinksBlockConfig,
  socialLinksBlockResolveConfig,
};

export type SocialLinksBlockConfig = typeof socialLinksBlockConfig;
